/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Limitedpartner2Inputs */

const en_coinvestments_limitedpartner2 = /** @type {(inputs: Coinvestments_Limitedpartner2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

/**
* | output |
* | --- |
* | "Organisation" |
*
* @param {Coinvestments_Limitedpartner2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_limitedpartner2 = /** @type {((inputs?: Coinvestments_Limitedpartner2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Limitedpartner2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_limitedpartner2(inputs)
});
export { coinvestments_limitedpartner2 as "coInvestments_limitedPartner" }